import React, { useState } from 'react';
import { FiX, FiMonitor, FiSmartphone } from 'react-icons/fi';
import acmeLogo from '../../assets/acmelogo.png';
import previewImage from '../../assets/reportscamtem.png';
import { FaFacebook, FaTwitter, FaInstagram } from 'react-icons/fa';

interface PreviewTemplateModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const FiSmartphoneComponent = FiSmartphone as unknown as React.ComponentType<{
  size?: number | string;
  className?: string;
}>;

const FiMonitorComponent = FiMonitor as unknown as React.ComponentType<{
  size?: number | string;
  className?: string;
}>;

const FiXComponent = FiX as unknown as React.ComponentType<{
  size?: number | string;
  className?: string;
}>;

const FaFacebookComponent = FaFacebook as unknown as React.ComponentType<{
  size?: number | string;
  className?: string;
}>;

const FaTwitterComponent = FaTwitter as unknown as React.ComponentType<{
  size?: number | string;
  className?: string;
}>;

const FaInstagramComponent = FaInstagram as unknown as React.ComponentType<{
  size?: number | string;
  className?: string;
}>;

const PreviewTemplateModal: React.FC<PreviewTemplateModalProps> = ({
  isOpen,
  onClose,
}) => {
  // State for toggling between desktop and mobile preview modes
  const [isMobile, setMobile] = useState(false);

  // Hide modal if not open
  if (!isOpen) return null;

  // Toggles the preview mode between desktop and mobile
  const togglePreviewMode = (mobile: boolean) => {
    setMobile(mobile);
  };

  return (
    <div className='fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50'>
      <div className='bg-white rounded-lg shadow-lg w-[800px] max-h-[90vh] relative flex flex-col'>
        {/* Header */}
        <div className='flex justify-between items-center p-6 flex-shrink-0'>
          <div>
            <h2 className='text-lg font-semibold text-gray-800'>
              Preview template
            </h2>
            <p className='text-sm text-gray-500'>Template Content Viewer</p>
          </div>
          <button onClick={onClose}>
            <FiXComponent
              size={22}
              className='text-gray-500 hover:text-gray-700'
            />
          </button>
        </div>

        {/* Top controls */}
        <div className=' py-2 flex items-center justify-between border border-b-0 mx-6 px-3 rounded-t-md flex-shrink-0'>
          <span className='text-sm text-gray-700 font-medium'>
            News Digest_Region
          </span>
          <div className='flex items-center gap-2'>
            <button
              className={`p-2 rounded-md border ${
                !isMobile ? 'bg-[#E0F8FB]' : 'hover:bg-gray-50'
              }`}
              onClick={() => togglePreviewMode(false)}
            >
              <FiMonitorComponent size={18} />
            </button>
            <button
              className={`p-2 rounded-md border ${
                isMobile ? 'bg-[#E0F8FB]' : 'hover:bg-gray-50'
              }`}
              onClick={() => togglePreviewMode(true)}
            >
              <FiSmartphoneComponent size={18} />
            </button>
          </div>
        </div>

        {/* Email Preview (scrollable section only) */}
        <div className='mx-6 mb-6 pl-4 pr-1 py-6 overflow-y-auto flex-1 border rounded-b-md bg-[#E1EAF0]'>
          <div
            className={`border shadow-md ${
              isMobile ? 'max-w-[400px]' : 'max-w-[600px]'
            } mx-auto bg-white`}
          >
            {/* Header */}
            <div className='flex justify-between items-center px-6 py-4'>
              <img src={acmeLogo} alt='Logo' className='h-30 object-contain' />
              <div className='flex gap-3 text-gray-500'>
                <FaFacebookComponent
                  size={20}
                  className='cursor-pointer hover:text-blue-600'
                />
                <FaTwitterComponent
                  size={20}
                  className='cursor-pointer hover:text-sky-500'
                />
                <FaInstagramComponent
                  size={20}
                  className='cursor-pointer hover:text-pink-500'
                />
              </div>
            </div>

            {/* Image */}
            <div className='px-6'>
              <img src={previewImage} alt='Furniture' className='w-full' />
            </div>

            {/* Content */}
            <div className='p-6 text-center'>
              <p className='text-purple-600 text-sm font-medium mb-2'>
                Our new article
              </p>
              <h3 className='text-xl font-semibold text-gray-800 mb-3'>
                Designing with Furniture
              </h3>
              <p className='text-[#667085] text-[13.2px] leading-relaxed'>
                Unleash your inner designer as we explore how furniture plays a
                vital role in creating stunning interiors, offering insights
                into choosing the right places, arranging them harmoniously, and
                infusing your space with personality and style
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// Export the PreviewTemplateModal component as the default export
export default PreviewTemplateModal;
